module.exports = __webpack_public_path__ + "static/media/zzz.e5a3ac93.svg";